var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regular-header"},[(_vm.data.title != undefined)?_c('h3',{domProps:{"innerHTML":_vm._s(_vm.data.title)}}):_vm._e(),(_vm.data.description != undefined)?_c('p',[_vm._v(_vm._s(_vm.data.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }